export default "__VITE_ASSET__nHBfObuq__"